/**
 * Replaces underscores and id tags found in API data.
 *
 * @param text {string}: Pre-processed string.
 *
 * @return {string}: String with underscores and id removed.
 */
const formatDataText = (text) => {
    return (text.trim())
        .replace(/_id$/, '')
        .replace(/_/g, ' ');
};

export default formatDataText;
